import { capitalGainsBondVsInvestment } from "../../engine/calculations";
import { TAX_NOTICE } from "../../lib/taxConfig";

const config = {
  key: "capital-gains-bond",
  title: "Capital Gains Bond vs Other Investment",
  category: "Tax",
  description: "Compare investing your LTCG in a Section 54EC capital-gains bond against paying the tax now and investing the rest elsewhere.",
  notice: TAX_NOTICE,
  fields: [
    { key: "ltcgAmount", label: "Long-term capital gain amount", type: "currency", default: 10_00_000, min: 1000, max: 10_00_00_000 },
    { key: "applicableTaxRatePct", label: "Applicable LTCG tax rate", type: "percent", default: 12.5, min: 0, max: 30 },
    { key: "bondRate", label: "54EC bond interest rate", type: "percent", default: 5.25, min: 0, max: 15 },
    { key: "bondLockYears", label: "Bond lock-in (years)", type: "number", default: 5, min: 1, max: 10 },
    { key: "altReturnRate", label: "Alternative investment expected return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const ltcgAmount = Number(values.ltcgAmount) || 0;
    const applicableTaxRatePct = Number(values.applicableTaxRatePct) || 0;
    const bondRate = (Number(values.bondRate) || 0) / 100;
    const bondLockYears = Number(values.bondLockYears) || 0;
    const altReturnRate = (Number(values.altReturnRate) || 0) / 100;

    const result = capitalGainsBondVsInvestment(ltcgAmount, applicableTaxRatePct, bondRate, bondLockYears, altReturnRate);
    const betterOption = result.advantage > 0 ? "54EC bond" : "Pay tax & invest elsewhere";

    return {
      headline: { label: "Better option", value: betterOption, format: "text" },
      extraHeadlines: [{ label: "Difference in your favour", value: Math.abs(result.advantage) }],
      breakdown: [
        { label: "Pay tax & invest ends with", value: result.payTaxAndInvest },
        { label: "54EC bond ends with", value: result.bondInvestment },
      ],
      series: [
        { name: "Pay tax & invest", amount: result.payTaxAndInvest },
        { name: "54EC bond", amount: result.bondInvestment },
      ],
    };
  },
};

export default config;
